export default function getSignifydSessionID($document) {
  const script = $document.getElementById('sig-api');
  const signifydSessionId = script?.getAttribute('data-order-session-id') || null;
  return signifydSessionId;
}
